import Icon from './Icon';

const Save = (props) => {
  // eslint-disable-next-line react/prop-types
  const { color, ...rest } = props;
  return (
    <Icon
      {...rest}
      title="Save"
      viewBox="0 0 24 24"
      pathFillRule="evenodd"
      pathClipRule="evenodd"
      path="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z"
      stroke={color || 'var(--color-text-primary)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      color="transparent"
    />
  );
};
export default Save;
